import React, {useContext} from 'react';
import {observer} from 'mobx-react';
import {bem} from '../utils/bem';
import DownloadContext from '../stores/DownloadContext';
import TranslationContext from '../utils/I18n';
import Block from './common/Block';
import Button from './common/Button';

const block = bem('downgrid');

const DownloadActionBar = () => {
	const store = useContext(DownloadContext);
	const t = useContext(TranslationContext);
	const {numSelectedDownloads, isDownloading} = store;
	const transKey = `downloads.${numSelectedDownloads === 1 ? 'selectionCount' : 'selectionCountPlural'}`;

	return numSelectedDownloads > 0 ? (
		<Block modifiers={{
			colorSchemeDefault: true,
			paddingLeftDefault: true,
			paddingLeftMultiDefault: true,
			paddingRightDefault: true,
			paddingRightMultiDefault: true,
			downloadActionBar: true
		}}>
			<div className={block('actionBar')}>
				<div>
					<span className={block('selCount')}>{t(transKey, {n: numSelectedDownloads})}</span>
					<Button
						modifiers={{default: true}}
						className={block('action', {loading: isDownloading})}
						onClick={() => store.download()}
						icon={isDownloading? {
							name: 'loading-spinner',
							width: 16,
							height: 16
						} : null}
					>{t('downloads.selection')}</Button>
				</div>
			</div>
		</Block>
	) : null;
};

export default observer(DownloadActionBar);
